module.exports = __webpack_public_path__ + "static/cross-d9a5cc0ac441e9d65f043691839c21b2.png";